import { event } from '@ngrx/signals/events';
import { type } from '@ngrx/signals';
import { KeycloakProfile, KeycloakResourceAccess, KeycloakRoles, KeycloakUserInfo } from 'keycloak-js';
import { Filter, KeycloakConfiguration } from '@models/online-reputation.models';

export const loadInitConfig = event(
    '[Application] Load init config',
    type<KeycloakConfiguration>()
);

export const loadUserInfo = event(
    '[Application] Load user info',
    type<KeycloakUserInfo>()
);

export const loadUserProfile = event(
    '[Application] Load user profile',
    type<{
        userProfile: KeycloakProfile,
        realmAccess: KeycloakRoles | undefined,
        resourceAccess: KeycloakResourceAccess | undefined,
        clientId: string
    }>()
);

export const applicationInitialized = event(
    '[Application] Initialized',
    type<Filter>()
);

export const showApplicationError = event(
  '[Application] Show application error',
  type<Error>()
);
